import React from "react";
import "./terms.css";

const Refund = () => {
  return (
    <div className="terms-page">
      <div className="top-header">
        <div className="header-left">
          <img
            src="/assets/img/InstaTenders - Logo reduced.png"
            alt="Office logo"
            className="login-brand-logo"
          />
        </div>
      </div>

      <div className="terms-container">
        <div className="terms-banner">
          <h1>Refund Policy</h1>
          <p>
            <strong>Effective Date:</strong> 1st January 2026
          </p>
          <p>
            <strong>Platform Name:</strong> InstaTenders
          </p>
          <p>
            <strong>Company Name:</strong> InstaTenders Solutions Private
            Limited
          </p>
        </div>
        <div className="terms-card">
          <div className="terms-section">
            <h3>1. Subscription services</h3>
            <p>
              We provide subscription-based procurement services through our
              mobile application with plans of 3 months, 6 months, and 12 months.
            </p>
          </div>

          <div className="terms-section">
            <h3>2. General refund policy</h3>
            <p>
              All payments made for subscriptions are generally non-refundable
              once the subscription is activated. Refunds will only be considered
              under the following conditions:
            </p>
            <ul>
              <li>Duplicate payment made by the user</li>
              <li>
                Payment deducted but subscription not activated due to technical
                issues
              </li>
              <li>Failed transactions where the amount was debited</li>
            </ul>
          </div>

          <div className="terms-section">
            <h3>3. How to request a refund</h3>
            <p>
              If eligible, users must request a refund within 7 days of the
              transaction by contacting our support team.
            </p>
          </div>

          <div className="terms-section">
            <h3>4. Processing time</h3>
            <p>
              Approved refunds will be processed within 5–7 business days to the
              original payment method.
            </p>
          </div>

          <div className="terms-section">
            <h3>5. Review and approval</h3>
            <p>
              We reserve the right to review and approve or reject refund
              requests based on verification.
            </p>
          </div>
        </div>
      </div>
      <div className="custom-footer">
        <div className="footer-top">
          <div className="footer-col left">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms & Conditions</a>
            <a href="/refund">Refund Policy</a>
            <a href="/cancellation">Cancellation Policy</a>
          </div>

          <div className="footer-col right">
            <p>
              <span>📍</span> 4/159, Thiru.vi.ka Industrial Estate, Labour
              Colony 1st Street, Guindy, Chennai - 600032, Tamil Nadu, India
            </p>
            <p className="phone">
              <span>📞</span> +91 9884713801
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          Copyright © 2026. All Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default Refund;
